// We use box-shadow as a border to achieve the "inset" effect
export const insetBorder = ({ width, color }: { width: number | string; color: string }) =>
  `inset 0 0 0 ${typeof width === 'number' ? `${width}px` : width} ${color}`
